(() => {
  'use strict';

  const BREEDS = Object.freeze({
    'bichon-frise': 'Bichon Frise',
    'poodle': 'Poodle',
    'labrador-retriever': 'Labrador Retriever',
    'golden-retriever': 'Golden Retriever',
    'french-bulldog': 'French Bulldog',
    'german-shepherd-dog': 'German Shepherd',
    'dachshund': 'Dachshund',
    'cocker-spaniel': 'Cocker Spaniel',
    'pembroke-welsh-corgi': 'Pembroke Welsh Corgi',
    'australian-shepherd': 'Australian Shepherd',
    'cavalier-king-charles-spaniel': 'Cavalier King Charles Spaniel',
    'beagle': 'Beagle',
    'border-collie': 'Border Collie',
    'staffordshire-bull-terrier': 'Staffordshire Bull Terrier',
    'rottweiler': 'Rottweiler',
    'yorkshire-terrier': 'Yorkshire Terrier',
    'mixed-or-unsure': 'dog'
  });
  const SIZES = new Set(['small', 'medium', 'large', 'size-varies']);

  const initialize = (root) => {
    if (root.dataset.problemBreedContextReady === 'true') return;
    root.dataset.problemBreedContextReady = 'true';
    const params = new URLSearchParams(window.location.search);
    const breedKey = params.get('breed') || '';
    const breedSize = params.get('breed_size') || '';
    const breedName = BREEDS[breedKey];
    if (!breedName || (breedSize && !SIZES.has(breedSize))) return;

    const title = root.querySelector('[data-problem-breed-context-title]');
    if (title) title.textContent = breedKey === 'mixed-or-unsure'
      ? 'Guidance for your dog'
      : `Guidance for your ${breedName}`;
    root.hidden = false;
  };

  const boot = () => document.querySelectorAll('[data-problem-breed-context]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
